import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import { ButtonScreenPoint, MapOxxoTopicOne, Phone } from "../objects/Topics";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";

export class SceneTopicThree extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();
	}

	create() {
		this.map = new MapOxxoTopicOne(this.loadingManager);
		this.add(this.map);
		this.add(this.characterSelected)

		this.phone = new Phone(this.loadingManager);
		this.phone.visible = false
		this.add(this.phone);

		this.buttonPointerScreen = new ButtonScreenPoint(this.loadingManager)
		this.buttonPointerScreen.visible = false
		this.buttonPointerScreen.rotation.y = -1
		this.add(this.buttonPointerScreen)
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	characterMoveInitScene() {
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.visible = true;
		this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
		this.characterSelected.rotation.set(0, -1.5145, 0);
	}


	resetActOne() {
		this.characterSelected.visible = false
	}

	sceneActivityOneState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic3.actScene, (step = "") => {
			switch (step) {
				case "move_desk":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
						this.characterSelected.visible = true
					});
					break;
				case "view_phone":
					this.camera.moveCameraToPoint(new Vector3(-12.0343, -0.5031, -1.9074), 1, new Vector3(-11.139, -0.55, -1.464), () => {
						this.camera.control.minDistance = 0.6;
						this.camera.control.maxDistance = 2;
					});
					this.phone.visible = true
					this.phone.position.set(-11.3, -0.95, -1.3)
					this.phone.rotation.set(0, -2, 0)
					break;
				case "hide_phone":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {

					});
					this.phone.visible = false
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}

	sceneActivityTwoState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic3.actScene, (step = "") => {
			switch (step) {
				case "view_desk_phone":
					this.camera.moveCameraToPoint(new Vector3(-11.9096, -0.5595, -0.9061), 1, new Vector3(-10.979, -0.55, -1.508), () => {
						this.camera.control.minDistance = 0.6;
						this.camera.control.maxDistance = 2;
						// this.camera.control.enableRotate = true;
						// this.camera.control.enablePan = true;
					});
					this.phone.visible = true
					this.phone.position.set(-11.3, -0.95, -1.3)
					this.phone.rotation.set(0, -1, 0)

					this.buttonPointerScreen.position.set(-11.4, -0.7, -1.26)
					this.buttonPointerScreen.scale.set(0.025, 0.025, 0.025)
					this.buttonPointerScreen.visible = true
					break;
				case "hide_desk_phone":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					});
					this.phone.visible = false
					this.phone.selectTexture(this.phone.namesTextures.topic3_act1_01)
					this.buttonPointerScreen.visible = false
					break;
				case "texture_1":
					this.phone.selectTexture(this.phone.namesTextures.topic3_act2_02)
					this.buttonPointerScreen.position.set(-11.4, -0.56, -1.35)
					break;
				case "texture_2":
					this.phone.selectTexture(this.phone.namesTextures.topic3_act2_03)
					this.buttonPointerScreen.position.set(-11.4, -0.79, -1.12)
					break;
				case "texture_3":
					this.phone.selectTexture(this.phone.namesTextures.topic3_act2_04)
					this.buttonPointerScreen.position.set(-11.4, -0.38, -1.3)
					break;
				case "texture_4":
					this.phone.selectTexture(this.phone.namesTextures.topic3_act2_05)
					this.buttonPointerScreen.position.set(-11.4, -0.7, -1.33)
					break;
				case "texture_5":
					this.phone.selectTexture(this.phone.namesTextures.topic3_act2_06)
					this.buttonPointerScreen.visible = false
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}
	sceneActivityThreeState() {
		this.characterMoveInitScene()
		this.mouseEvents.disposeInteractions()

		ObserverEmitter.on(EVENTS.tema6.topic3.actScene, (step = "") => {
			switch (step) {
				case "view_desk_phone":
					this.camera.moveCameraToPoint(new Vector3(-11.9096, -0.5595, -0.9061), 1, new Vector3(-10.979, -0.55, -1.508), () => {
						this.camera.control.minDistance = 0.6;
						this.camera.control.maxDistance = 2;
					});
					this.phone.selectTexture(this.phone.namesTextures.topic3_act3_01)
					this.phone.visible = true
					this.phone.position.set(-11.4, -0.95, -1.45)
					this.phone.rotation.set(0, -1, 0)

					this.buttonPointerScreen.visible = false
					break;
				case "hide_desk_phone":
					this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					});
					this.phone.visible = false
					break;
				case "texture_2":
					this.phone.selectTexture(this.phone.namesTextures.topic3_act3_02)
					break;
				case "texture_3":
					this.phone.selectTexture(this.phone.namesTextures.topic3_act3_03)
					break;
				default:
					this.resetActOne()
					break;
			}
		})
	}

	listeners() {

	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;

					this.activeAudio()

				})
				break;
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityOneState();
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true
					this.activeAudio()

					this.sceneActivityTwoState();
				});
				break;
			case 3:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()

					this.sceneActivityThreeState();
				});
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.ennablePan = false;

					this.characterSelected.visible = false
				});
				break;
		}
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				// const name = interactions[0].object.name;
				// ObserverEmitter.emit(EVENTS.tema3.listenClick, name);
			}
		});
	}

	renderAnimations(delta) {
	}
}
